import { assignInlineVars } from "@vanilla-extract/dynamic"
import { isDeepEqual } from "remeda"
import { createMemo, For } from "solid-js"
import {
  fireworksContainerClass,
  fireworksDelayVar,
  fireworksParticleClass,
  fireworksSizeVar,
  fireworksTxVar,
  fireworksTyVar,
} from "./fireworks.css"

export function Fireworks() {
  const particles = createMemo(
    () =>
      Array.from({ length: 50 }, () => ({
        tx: (Math.random() - 0.5) * 800,
        ty: (Math.random() - 0.5) * 800,
        delay: Math.random() * 0.5,
        size: Math.random() * 4 + 4,
      })),
    { equals: isDeepEqual },
  )

  return (
    <div class={fireworksContainerClass}>
      <For each={particles()}>
        {particle => (
          <div
            class={fireworksParticleClass}
            style={assignInlineVars({
              [fireworksTxVar]: `${particle.tx}px`,
              [fireworksTyVar]: `${particle.ty}px`,
              [fireworksDelayVar]: `${particle.delay}s`,
              [fireworksSizeVar]: `${particle.size}px`,
            })}
          />
        )}
      </For>
    </div>
  )
}
